import React from "react";

function MusicIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.37"
      height="25"
      viewBox="0 0 23.37 25"
    >
      <g id="Group_28601" data-name="Group 28601" transform="translate(0)">
        <rect
          id="Rectangle_12944"
          data-name="Rectangle 12944"
          width="23"
          height="25"
          transform="translate(0)"
          fill="red"
          opacity="0"
        />
        <path
          id="Path_18485"
          data-name="Path 18485"
          d="M24.343,3V20.147A4.907,4.907,0,1,1,21.886,15.9V5.45H10.829v14.7A4.907,4.907,0,1,1,8.371,15.9V3ZM5.914,22.6a2.45,2.45,0,1,0-2.457-2.45A2.453,2.453,0,0,0,5.914,22.6Zm13.514,0a2.45,2.45,0,1,0-2.457-2.45A2.453,2.453,0,0,0,19.429,22.6Z"
          transform="translate(-0.973 -1.814)"
          fill="#fff"
        />
      </g>
    </svg>
  );
}

export default MusicIcon;
